import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { Middleware } from '@reduxjs/toolkit';
import { message } from 'antd';

/**
 * Log a warning and show a toast!
 */
export const rtkQueryErrorLogger: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    console.warn('We got a rejected action!');

    const serverMessage = action.payload?.data?.message;

    if (serverMessage) {
      if (serverMessage.includes('sk_live')) {
        message.error('Invalid Stripe ID', 5);
      } else {
        message.error(serverMessage, 5);
      }
    } else {
      message.error('Something went wrong!');
    }
  }

  return next(action);
};
